module.exports = __webpack_public_path__ + "src/components/status-bubble-selected.67c12235b10b9d271e3ed5bef58d4f9e.svg";